// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"805":"b1c3077d","900":"0fae0ae5"}[chunkId] + ".chunk.js";
};